import { HelpCircle } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { useHelpDrawer } from '@/contexts/HelpDrawerContext';
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from '@/components/ui/tooltip';

/**
 * HelpButton — an inline "? Help" button placed in each page's toolbar.
 * Opens the HelpDrawer. No absolute positioning — it sits naturally in the
 * flex toolbar as the last item on the right.
 */
export function HelpButton() {
  const { openHelp } = useHelpDrawer();

  return (
    <TooltipProvider delayDuration={400}>
      <Tooltip>
        <TooltipTrigger asChild>
          <Button
            variant="outline"
            size="sm"
            onClick={() => openHelp('functionality')}
            aria-label="Open help panel"
            className="gap-1.5 h-8 px-3 text-xs font-medium border-border hover:bg-accent hover:text-accent-foreground"
          >
            <HelpCircle className="h-3.5 w-3.5" />
            Help
          </Button>
        </TooltipTrigger>
        <TooltipContent side="bottom" className="text-xs">
          Help, guides &amp; feature tour
        </TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
}
